/** @format */

import React, { Component } from 'react';
import { Container, Header, Dimmer, Loader } from 'semantic-ui-react';
import StatisticToolbar from './StatisticsToolbar/StatisticsToolbar';
import { observer, inject } from 'mobx-react';

import StatsOverview from './StatisticOverview/StatisticsOverview';

@inject('StatsStore')
@observer
class Stats extends Component {
  componentDidMount() {
    const { StatsStore } = this.props;
    StatsStore.fetchStats();
  }

  refreshStats = () => {
    const { StatsStore } = this.props;
    StatsStore.refreshStats();
  };

  render() {
    const { StatsStore } = this.props;
    const { permissionDenied, loading, noResult } = StatsStore.stats;
    if (!loading) {
      return (
        <div>
          <StatisticToolbar refresh={() => this.refreshStats()} />
          <Container className="content-container">
            {!permissionDenied ? (
              !noResult ? (
                <StatsOverview />
              ) : (
                <Header as="h2" color="red">
                  Non ci sono Statistiche per questo periodo.
                </Header>
              )
            ) : (
              <Header as="h2" color="red">
                Accesso Negato
              </Header>
            )}
          </Container>
        </div>
      );
    } else {
      return (
        <Dimmer active inverted>
          <Loader>Caricando le Statistiche</Loader>
        </Dimmer>
      );
    }
  }
}

export default Stats;
